import { createFileRoute, useNavigate } from '@tanstack/react-router'
import SlideWizard from '@/components/learning-paths/SlideWizard'
import { emotionalHijackChapter } from '@/learning-paths/incode/emotional-hijack/chapter'

export const Route = createFileRoute('/_auth/learning-journeys/emotional-hijack')({
  component: EmotionalHijackRoute,
})

function EmotionalHijackRoute() {
  const navigate = useNavigate()

  const handleExit = () => {
    navigate({
      to: '/learning-journeys/scam-fundamentals',
      search: { invitationcode: undefined, __clerk_ticket: undefined },
    })
  }

  return (
    <SlideWizard
      chapter={emotionalHijackChapter}
      onExit={handleExit}
      onComplete={handleExit}
    />
  )
}
